import React, { useEffect, useState } from 'react';
import styles from '../formStyles.module.css';
import Button from '@/components/common/Button';
import Api from '@/api';
import ContactInfoForm from './ContactInfoForm';
import { useLayoutContext } from '@/context/LayoutContext';
import { useTranslations } from 'next-intl';
import { TRIGGERS } from '@/api/global';
import MainIcons from '@/icons/main';

export default function ContactFormInside() {
  const { trigger, setTrigger, setServerMessage, showError } = useLayoutContext();
  const [loading, setLoading] = useState(false);
  const tCommon = useTranslations('common');
  const empty = {
    name: '',
    email: '',
    subject: '',
    content: '',
    error: {
      name: false,
      email: false,
      subject: false,
      content: false,
    },
    messages: {
      name: tCommon('requiredField'),
      email: tCommon('requiredField'),
      subject: tCommon('requiredField'),
      content: tCommon('requiredField'),
    },
  };
  const [info, setInfo] = useState(empty);

  const handleSubmit = () => {
    let check = checkError();
    console.log('check==', check);
    if (!check) {
      const params = {
        name: info?.name,
        email: info?.email,
        subject: info?.subject,
        content: info?.content,
      };

      let apiCall = Api.userUpdate;
      setLoading(true);
      apiCall(params)
        .then((res) => {
          setData(undefined);
          setTrigger(TRIGGERS.RERENDER);
          setLoading(false);
          setInfo(empty);
          setServerMessage({
            type: 'success',
            name: 'error',
            text: 'پیام شما با موفقیت ارسال شد.',
          });
        })
        .catch((err) => {
          setLoading(false);

          showError(err);
        });
      // setData({ ...info });
    }
  };
  const checkError = () => {
    let dummy = { ...info };
    let result = false;
    let array = ['subject'];
    let values = ['name', 'email', 'content'];

    values?.map((item, i) => {
      if (String(info?.[item])?.trim()?.length == 0) {
        dummy.error[item] = true;
        result = true;
      }
    });
    array?.map((item, i) => {
      if (info?.[item]?.length == 0) {
        dummy.error[item] = true;
        result = true;
      }
    });
    setInfo({ ...dummy });
    return result;
  };
  const handleCancel = () => {
    setInfo(data);
  };

  return (
    <div className={`${styles.container}`}>
      <ContactInfoForm info={info} setInfo={setInfo} />
      <div className={`${styles.buttonContainerContact}`}>
        <p className={`${styles.textContact}`}>اطلاعات شما محرمانه می‌ماند.</p>
        <Button
          onClick={() => handleSubmit()}
          className={`btn btn-primary w-full squareButton ${styles.contactButton}`}
          wrapperStyle={`${styles.contactButton}`}
          loading={loading}
          showAnimation={false}
        >
          <MainIcons.send fill="var(--paper)" width="17px" height="17px" />
          ارسال پیام
        </Button>
      </div>
    </div>
  );
}
